export const CONFIRMED = 'CONFIRMED'
export const UNCONFIRMED = 'UNCONFIRMED'

export const INDIVIDUAL = 'Individual'
export const NURSE = 'Nurse'
export const HOSPITAL = 'Hospital'
export const ADMIN = 'Super Admin'

export const EMAIL = 'email'
export const SMS = 'sms'

export const WAITING = 'Waiting'
export const APPROVED = 'Approved'
export const REJECTED = 'Rejected'
export const BLOCKED = 'Blocked'
export const UNBLOCK = 'Unblock'
export const VERIFIED = 'Verified'
export const WAITING_FOR_APPROVAL = 'Waiting for Approval'

export const FORCE_CHANGE_PASSWORD = 'FORCE_CHANGE_PASSWORD'
export const USER_PASSWORD_AUTH = 'USER_PASSWORD_AUTH'
export const NEW_PASSWORD_REQUIRED = 'NEW_PASSWORD_REQUIRED'
export const TENANT_ID_CREATED_AT_INDEX = 'tenant_id-created_at-index'
export const USER_ID_CREATED_AT_INDEX = 'user_id-created_at-index'
export const HOSPITAL_ID_CREATED_AT_INDEX = 'hospital_id-created_at-index'
export const DEVICE_ID_CREATED_AT_INDEX = 'device_id-created_at-index'
export const PATIENT_ID_CREATED_AT_INDEX = 'patient_id-created_at-index'
export const COUNTRY_ID_UUID_INDEX = 'country_id-uuid-index'
export const ROLE_CREATED_AT_INDEX = 'role-created_at-index'
export const COUNTRY_NAME_INDEX = 'country_name-index'
export const STATUS_INDEX = 'status-index'